import { defa }          from 'defa-object';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.BatteryAlert
 * The DEFA BatteryAlert model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	powerconfig: '/homeAutomation/powerConfiguration?attrs=',
};

const BatteryAlert = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.powerconfig + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			// Backup battery alert
			batteryAlarmMask: null,
			batteryAlarmMaskError: null,
			/*
			 batteryFailure : false,
			 lowBattery     : false,
			 */
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		if(response) {
			let newModelAttributes = {};
			
			if(response.batteryAlarmMask){
				this.parseAttribute('batteryAlarmMask', response.batteryAlarmMask, options, newModelAttributes);
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'batteryAlerts' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return {
			batteryAlarmMask: {
				batteryFailure: 'ON' === this.get('batteryEnabled'),
				lowBattery    : 'ON' === this.get('batteryEnabled'),
			}
		};
	},
	
	getAttributes: function() {
		return 'batteryAlarmMask';
	},
	
} );

export default BatteryAlert;
